import { styled, Theme } from '@mui/material';

export const sxStyles = {
  title: (theme: Theme) => ({
    marginBottom: '1.5rem',
    color: theme.palette.primary.main,
  }),
  description: {
    maxWidth: '560px',
    width: '100%',
  },
  infoItem: {
    '& > p:first-of-type': {
      marginBottom: '0.125rem',
    },
  },
};

export const StyledAboutSection = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  justifyContent: 'space-between',
  paddingTop: '2rem',
  paddingBottom: '2rem',

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    paddingTop: '2.75rem',
    paddingBottom: '2.75rem',
  },
}));

export const StyledTextWrap = styled('div')(({ theme }) => ({
  paddingBottom: '1rem',
  paddingRight: 0,
  width: '100%',
  borderBottom: `1px solid ${theme.palette.grey['300']}`,

  [theme.breakpoints.up('md')]: {
    maxWidth: '656px',
    borderRight: `1px solid ${theme.palette.grey['300']}`,
    borderBottom: 'none',
    paddingBottom: 0,
    paddingRight: '1rem',
  },
}));

export const StyledInformationWrap = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: '4rem',
  padding: '1rem 0',
  width: '100%',

  '& > div': {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },

  [theme.breakpoints.up('md')]: {
    justifyContent: 'space-between',
    padding: '0 2rem',
  },
}));
